import React from "react";
import useThemeConfig from "src/themes/useThemeConfig";

export default function ProfileButton(props) {
  const config = useThemeConfig();
  const ThemedProfileButton = config.components.ProfileButton;

  return <ThemedProfileButton {...props} />;
}
